import { PlayIcon } from "../mediaPanel/videoPlayer/custom-player.styled"

const feature = {
    "lessons": {
        title: "Lessons",
        description: "Lessons",
        icon: PlayIcon

    },
    "shoppable_videos": {
        title: "Videos",
        description: "Videos",
        icon: PlayIcon

    }
}

export const shoppableVideoConfigToPanelDescriptionText = (featureName: string) => {
    return feature[featureName]?.description ?? "No Description"
}

export const shoppableVideoConfigToPanelTitleText = (featureName: string) => {
    return feature[featureName]?.title ?? "No Title"
}

export const shoppableVideoConfigToPanelIcon = (featureName: string) => {
    return feature[featureName]?.icon
}
